module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-18.95efccd7.svg";